/* eslint-disable import/no-deprecated */
import React from 'react';
import { Typography } from '../../deprecated/Typography';
import { identifyComponent } from '../../util';
import { Box } from '../Box';

export interface InputDescriptionProps {
  description: string;
  invalid?: boolean;
  id?: React.ComponentProps<typeof Typography>['id'];
}

export const InputDescription: React.FC<InputDescriptionProps> = ({
  description,
  invalid = false,
  id,
}) => (
  <Box
    data-component="InputDescription"
    padding={[4, 0, 4, 0]}
    {...identifyComponent('input-description')}
  >
    <Typography variant="body3" color={invalid ? 'red' : 'neutrals-n7'} id={id}>
      {description}
    </Typography>
  </Box>
);
